module.exports = __webpack_public_path__ + "img/icon_tips3.e7f97c7e.png";